import api from "../config/apiConfig";
import { toast } from "react-toastify";
import {
  getUserDetails,
  storeAccessCondition,
  storeCompanyDetails,
  storeDeleteAccess,
  storeSelectedCompany,
  storeUserDetails,
  storeUserToken,
} from "../utils/auth";

import { getAdminId } from "../utils/authId";

import WebSocketOnline from "../../src/services/onlineSocketService";
import { getRegisterId } from "../utils/authId";

export const signUp = async (formData) => {
  try {
    const formPayload = new FormData();
    for (const key in formData) {
      if (formData[key]) {
        formPayload.append(key, formData[key]);
      }
    }
    const response = await api.post("api/sign_up/", formPayload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response) {
      storeUserToken(response.data.register_details.token);
      storeUserDetails(response.data.register_details.user_details);
      toast.success("Registration successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error("Registration failed. Please try again.");
    }
  }
};

export const sendOTP = async (email) => {
  try {
    const response = await api.post("api/registerOtp/", { email });
    return response.data.register_otp_data.register_otp_code;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error("Failed to send OTP. Please try again.");
    }
  }
};

export const companyRegister = async (formData) => {
  const id = getAdminId();
  const data = {
    ...formData,
    admin: id,
  };
  try {
    const response = await api.post("api/company_register/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response) {
      // storeUserToken(response.data.register_details.token);
      storeCompanyDetails(response.data.company_details);
      storeSelectedCompany(response.data.company_details);

      toast.success("Company registered successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error(" failed.");
    }
  }
};

export const companyValidateApi = async (formData) => {
  const id = getAdminId();
  const data = {
    ...formData,
    admin: id,
  };
  try {
    const response = await api.post("api/company_validation/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response) {
      // storeUserToken(response.data.register_details.token);
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error(" failed.");
    }
  }
};

// import api from "../config/apiConfig";
// import {
//   getUserDetails,
//   storeAccessCondition,
//   storeCompanyDetails,
//   storeSelectedCompany,
//   storeUserDetails,
//   storeUserToken,
// } from "../utils/auth";

export const signIn = async (credentials) => {
  const data = {
    ...credentials,
    device_name: "Web",
  };
  try {
    const response = await api.post("api/login/", data);

    if (response) {
      storeUserToken(response.data.login_data.token);
      storeUserDetails(response.data.login_data.employee_details);
      storeCompanyDetails(response.data.login_data.company_details);
      storeSelectedCompany(response.data.login_data.company_details[0]);
      storeDeleteAccess(response.data.chat_delete_control);
      // console.log(
      //   response.data.login_data.access_category[0],
      //   "access_category"
      // );
      storeAccessCondition(response.data.login_data.access_category[0]);
      WebSocketOnline.connect(response.data.login_data.token); // Connect WebSocket after login
    }

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error("Login failed. Please try again.");
    }
  }
};

export const logOut = async () => {
  const regId = getRegisterId();
  const userDetails = getUserDetails();
  const data = {
    register_id: regId,
    fcmToken: userDetails.fcmToken,
  };
  try {
    await api.post(`api/logout/`, data);
  } catch (error) {}
};

//Change Password

export const ChangePasswordApi = async (payload) => {
  // const regId = getRegisterId();
  // const userDetails = getUserDetails();
  //   const data = {
  //     register_id: regId,
  //     payload,
  //     // fcmToken: userDetails.fcmToken,
  //   };
  try {
    await api.post(`api/change_password/`, payload);
  } catch (error) {
    throw error.response.data;
  }
};

//Forgot Password

export const ForgotPasswordApi = async (payload) => {
  try {
    await api.post(`api/forget_password/`, payload);
    toast.success("Updated successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
  } catch (error) {
    throw error.response.data;
  }
};

//Forgot Password Email Validation

export const ForgotOTPApi = async (email) => {
  try {
    const response = await api.post("api/forget_email_validation/", { email });
    // console.log("______________", response.data);

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data;
    } else {
      throw new Error("Failed to send OTP. Please try again.");
    }
  }
};
